import { DESIGN_MODES, GROUND_MOUNT_DEFAULT_PITCH, IMAGERY_PROVIDER,
	MIN_PANELS_REQUIRED_FOR_DESIGN_TO_QUALIFY, ROOF_DESIGN_MODES, SHADING_STATUS } from '../../../../constants';

export function getInitialState() {
	return {
		allPanels: [],
		jpgUrl: '',
		latLng: '',
		boundingBox: {
			ne: {
				latitude: 0,
				longitude: 0,
			},
			sw: {
				latitude: 0,
				longitude: 0,
			},
		},
		selectedPanels: [],
		uuid: '',
		externalId: '',
		imgWidth: 0,
		imgHeight: 0,
		rasterSolarPanels: [],
		offsetIndex: {
			offset120: 0,
			offset150: 0,
		},
		panel: {
			wattage: 0,
			key: '',
			height: 0,
			width: 0,
			panelName: '',
		},
		roofSegs: {},
		roofSegsFromWhichUserHasSelectedPanels: [],
		org: {
			setting: {
				showToggleForAllPanels: false,
				acceptsAnnualEnergy: false,
				canEdit: false,
				canToggle3d: true,
				enableOffsetWarning: false,
				isB2C: false,
				defaultFlatPitchDeg: GROUND_MOUNT_DEFAULT_PITCH,
				defaultDrawnFacetType: null,
				minPanelsRequiredForDesignToQualify: MIN_PANELS_REQUIRED_FOR_DESIGN_TO_QUALIFY,
			},
			panelKeys: []
		},
		showAllPanels: false,
		selectedPanelKey: '',
		allRoofSegs: [],
		imagerySource: IMAGERY_PROVIDER.SUNROOF as ImagerySource,
		// isSyncedWithParent: false,
		mode: DESIGN_MODES.DEFAULT,
		obstructions: [],
		isSunroofAvailable: false,
		missingRoofPolygon: false,
		createdAt: '',
		updatedAt: '',
		editableFacets: [], 
		enableEditFacet: false,
		enableDeletePoints: false,
		isEdited: false,
		isSelected: false,
		facetHistory: [],
		currentIndex: -1,
		imageryCapturedDate: null,
		solarDataCapturedDate: null,
		imageryQuality: undefined,
		autoSwitchStatus: null,
		billingLogs: [],
		designType: 'SOLAR' as DesignType,
		lidarCapturedDate: null,
		roofDesignMode: ROOF_DESIGN_MODES.DEFAULT,
		roofDesignSource:  IMAGERY_PROVIDER.SUNROOF as ImagerySource,
		groundMetersPerPixel: 0.1, //Default UTM values
		specialEdges: [],
		houseBoundingBox: [],
		panelsKeysForWhichDesignIsAvailable: [],
		customMaps: [],
		showAutoDetectedEdges: false,
		allGutterLines:[],
		dsmEdits: [],
		shadingAnalysis: {
			dsmEdits: [],
			shadingStatus: SHADING_STATUS.COMPLETED,
			dsmVersion: 0,
			shadingVersion: 0,
			dsmDirty: false,
		}
	};
}